import React, { useState } from 'react';
import { Phone, ShieldCheck, Star, MapPin, ArrowRight, CheckCircle2, ChevronDown, CheckCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Hero() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <section className="relative bg-navy text-white min-h-[90vh] flex items-center overflow-hidden" data-id="element-230">
      {/* Cinematic Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1621905252507-b35492cc74b4?auto=format&fit=crop&q=80&w=2000')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-231"></div>
      <div className="absolute inset-0 bg-gradient-to-r from-navy/95 via-navy/85 to-navy/50 z-[1]" data-id="element-232"></div>
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-navy/90 to-transparent z-[1]" data-id="element-233"></div>
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-accent/10 blur-[120px] rounded-full pointer-events-none z-[2]" data-id="element-234"></div>
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-[2]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-235"></div>

      <div className="max-w-7xl mx-auto px-4 relative z-10 grid lg:grid-cols-12 gap-12 lg:gap-8 items-center py-16 lg:py-20 pb-28 lg:pb-36" data-id="element-236">
        {/* Left Content */}
        <div className="lg:col-span-7 space-y-7" data-id="element-237">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex items-center gap-2 bg-white/15 border border-white/30 rounded-full p-1 pr-4 text-sm font-semibold backdrop-blur-md" data-id="element-238">
            <div className="bg-accent text-white rounded-full p-1.5 flex items-center justify-center relative" data-id="element-239">
              <div className="absolute inset-0 rounded-full border border-accent animate-ping opacity-50" data-id="element-240"></div>
              <MapPin className="w-3.5 h-3.5 relative z-10" data-id="element-241" />
            </div>
            <span className="text-white" data-id="element-242">
              Based in Huntingdale • Serving Perth's South
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-[4.25rem] font-heading font-extrabold leading-[1.08] tracking-tighter text-white" data-id="element-243">
            Perth's South Side electrician.
            <br data-id="element-244" />
            On time, fixed price,
            <br data-id="element-245" />
            <span className="text-accent relative inline-block mt-1" data-id="element-246">
              fully licensed.
              <svg className="absolute w-full h-4 -bottom-2 left-0 text-accent/60" viewBox="0 0 200 9" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-247">
                <path d="M2.00025 6.99997C37.5684 2.82494 116.51 -1.48625 198.001 6.99997" stroke="currentColor" strokeWidth="3" strokeLinecap="round" data-id="element-248" />
              </svg>
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="text-lg md:text-xl text-gray-200 max-w-2xl leading-relaxed" data-id="element-249">
            Same-day quotes. 15-minute callback. 441 five-star Google reviews.
            Backed by the Completely Electrical Guarantee.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex flex-wrap items-center gap-3 text-sm font-bold" data-id="element-250">
            <span className="flex items-center gap-2 bg-white/15 px-3 py-1.5 rounded-full border border-white/20 text-white" data-id="element-251">
              <ShieldCheck className="w-4 h-4 text-emerald-400" data-id="element-252" /> Fully
              Licensed
            </span>
            <span className="flex items-center gap-2 bg-white/15 px-3 py-1.5 rounded-full border border-white/20 text-white" data-id="element-253">
              <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-254" /> 5.0
              Google Rated
            </span>
            <span className="flex items-center gap-2 bg-emerald-500/20 px-3 py-1.5 rounded-full border border-emerald-500/30 text-emerald-300" data-id="element-255">
              <CheckCircle2 className="w-4 h-4" data-id="element-256" /> 441 Reviews
            </span>
            <span className="flex items-center gap-2 bg-white/15 px-3 py-1.5 rounded-full border border-white/20 text-white" data-id="element-257">
              After-hours emergency
            </span>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-258">
            <a href="#quote" className="group relative bg-gradient-to-r from-accent via-accent-300 to-accent hover:from-accent-600 hover:via-accent-400 hover:to-accent-600 text-white px-8 py-4 rounded-xl font-extrabold text-lg text-center transition-all shadow-[0_0_20px_rgba(62,164,78,0.3)] hover:shadow-[0_0_30px_rgba(62,164,78,0.5)] flex items-center justify-center gap-2 hover:-translate-y-1 overflow-hidden animate-shimmer bg-[length:200%_100%]" data-id="element-259">
              Get Your Free Quote
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-260" />
            </a>
            <a href="tel:0418381988" className="bg-white/15 hover:bg-white/25 border border-white/30 text-white px-8 py-4 rounded-xl font-extrabold text-lg flex items-center justify-center gap-2 transition-all backdrop-blur-sm hover:-translate-y-1" data-id="element-261">
              <Phone className="w-5 h-5" data-id="element-262" />
              Call 0418 381 988
            </a>
          </motion.div>

          {/* Mobile scroll prompt */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.5,
          duration: 0.5
        }} className="lg:hidden flex items-center gap-2 text-white/60 text-sm font-medium pt-2" data-id="element-263">
            <ChevronDown className="w-4 h-4 animate-bounce" data-id="element-264" />
            Scroll for instant quote
          </motion.div>
        </div>

        {/* Right Form - WHITE CARD */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        x: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        type: 'spring'
      }} className="lg:col-span-5 relative" id="quote" data-id="element-265">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden relative" data-id="element-266">
            <div className="h-1.5 w-full bg-gradient-to-r from-accent-400 to-accent-600" data-id="element-267"></div>

            <div className="p-6 md:p-8" data-id="element-268">
              <AnimatePresence mode="wait" data-id="element-269">
                {!isSubmitted ? <motion.div key="form" initial={{
                opacity: 1
              }} exit={{
                opacity: 0,
                y: -10
              }} transition={{
                duration: 0.3
              }} data-id="element-270">
                    <h3 className="text-2xl font-heading font-extrabold mb-1 text-navy" data-id="element-271">
                      Get Your Free Quote Today
                    </h3>
                    <p className="text-gray-600 mb-5 text-sm font-medium" data-id="element-272">
                      No obligation. Upfront pricing. Fast response.
                    </p>

                    <form className="space-y-3.5" onSubmit={handleSubmit} data-id="element-273">
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5" data-id="element-274">
                        <div data-id="element-275">
                          <label className="block text-xs font-bold text-navy mb-1.5" data-id="element-276">
                            Your Name
                          </label>
                          <input type="text" placeholder="e.g. Sarah Mitchell" className="w-full px-4 py-3 rounded-xl bg-white border border-gray-300 text-navy placeholder-gray-400 focus:border-accent focus:ring-2 focus:ring-accent/20 outline-none transition-all font-medium text-sm" data-id="element-277" />
                        </div>
                        <div data-id="element-278">
                          <label className="block text-xs font-bold text-navy mb-1.5" data-id="element-279">
                            Phone Number
                          </label>
                          <input type="tel" placeholder="04XX XXX XXX" className="w-full px-4 py-3 rounded-xl bg-white border border-gray-300 text-navy placeholder-gray-400 focus:border-accent focus:ring-2 focus:ring-accent/20 outline-none transition-all font-medium text-sm" data-id="element-280" />
                        </div>
                      </div>
                      <div data-id="element-281">
                        <label className="block text-xs font-bold text-navy mb-1.5" data-id="element-282">
                          Service Required
                        </label>
                        <select className="w-full px-4 py-3 rounded-xl bg-white border border-gray-300 text-navy focus:border-accent focus:ring-2 focus:ring-accent/20 outline-none transition-all font-medium appearance-none cursor-pointer text-sm" data-id="element-283">
                          <option value="" data-id="element-284">Select a Service...</option>
                          <option value="emergency" data-id="element-285">
                            After-hours emergency
                          </option>
                          <option value="lighting" data-id="element-286">
                            Lighting upgrade / new build lighting
                          </option>
                          <option value="switchboard" data-id="element-287">
                            Switchboard upgrade
                          </option>
                          <option value="hotwater" data-id="element-288">Hot water system</option>
                          <option value="aircon" data-id="element-289">
                            Air conditioning (split or evap)
                          </option>
                          <option value="smokealarms" data-id="element-290">
                            Smoke alarms / compliance certificate
                          </option>
                          <option value="faultfinding" data-id="element-291">
                            Fault finding / additional power points
                          </option>
                          <option value="commercial" data-id="element-292">
                            Commercial / industrial enquiry
                          </option>
                          <option value="other" data-id="element-293">Other</option>
                        </select>
                      </div>
                      <div data-id="element-294">
                        <label className="block text-xs font-bold text-navy mb-1.5" data-id="element-295">
                          When Do You Need This?
                        </label>
                        <select className="w-full px-4 py-3 rounded-xl bg-white border border-gray-300 text-navy focus:border-accent focus:ring-2 focus:ring-accent/20 outline-none transition-all font-medium appearance-none cursor-pointer text-sm" data-id="element-296">
                          <option value="" data-id="element-297">Select timing...</option>
                          <option value="today" data-id="element-298">Today, it's urgent</option>
                          <option value="week" data-id="element-299">This week</option>
                          <option value="month" data-id="element-300">This month</option>
                          <option value="planning" data-id="element-301">Just planning ahead</option>
                        </select>
                      </div>
                      <div data-id="element-302">
                        <label className="block text-xs font-bold text-navy mb-1.5" data-id="element-303">
                          Postcode (Perth South)
                        </label>
                        <select className="w-full px-4 py-3 rounded-xl bg-white border border-gray-300 text-navy focus:border-accent focus:ring-2 focus:ring-accent/20 outline-none transition-all font-medium appearance-none cursor-pointer text-sm" data-id="element-304">
                          <option value="" data-id="element-305">Select your postcode...</option>
                          <option value="6107" data-id="element-306">
                            6107 Beckenham / Cannington
                          </option>
                          <option value="6108" data-id="element-307">6108 Gosnells / Thornlie</option>
                          <option value="6109" data-id="element-308">
                            6109 Maddington / Kenwick
                          </option>
                          <option value="6110" data-id="element-309">
                            6110 Huntingdale / Southern River
                          </option>
                          <option value="6112" data-id="element-310">
                            6112 Armadale / Harrisdale
                          </option>
                          <option value="6125" data-id="element-311">6125 Canning Vale</option>
                          <option value="6147" data-id="element-312">
                            6147 Bull Creek / Leeming
                          </option>
                          <option value="6149" data-id="element-313">6149 Murdoch</option>
                          <option value="6164" data-id="element-314">6164 Cockburn</option>
                          <option value="6210" data-id="element-315">6210 Mandurah</option>
                          <option value="6230" data-id="element-316">6230 Golden Bay</option>
                          <option value="other" data-id="element-317">Other Perth metro</option>
                        </select>
                      </div>
                      <button type="submit" className="group w-full bg-accent hover:bg-accent-600 text-white font-extrabold py-4 rounded-xl transition-all text-lg flex items-center justify-center gap-2 shadow-lg hover:shadow-accent/20" data-id="element-318">
                        Get My Free Quote
                        <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-319" />
                      </button>

                      <div className="flex items-center justify-center gap-1.5 text-[11px] text-gray-500 font-medium" data-id="element-320">
                        <CheckCircle className="w-3 h-3 text-emerald-500" data-id="element-321" />
                        No call-out fee for quotes. No obligation. Text-back
                        within 15 minutes.
                      </div>

                      {/* Named Guarantee */}
                      <div className="bg-cream border border-accent/20 rounded-xl p-3 mt-1" data-id="element-322">
                        <div className="flex items-start gap-2.5" data-id="element-323">
                          <ShieldCheck className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-324" />
                          <div data-id="element-325">
                            <span className="text-xs font-extrabold text-navy block" data-id="element-326">
                              The Completely Electrical Guarantee
                            </span>
                            <span className="text-xs text-slate" data-id="element-327">
                              Quality workmanship, every time. We don't cut
                              corners.
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="text-center" data-id="element-328">
                        <span className="text-[11px] text-gray-500 font-medium" data-id="element-329">
                          441+ five-star Google reviews from happy customers
                        </span>
                      </div>
                    </form>
                  </motion.div> : <motion.div key="confirmation" initial={{
                opacity: 0,
                y: 10
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.4
              }} className="text-center py-8" data-id="element-330">
                    <div className="w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-331">
                      <CheckCircle className="w-8 h-8 text-emerald-600" data-id="element-332" />
                    </div>
                    <h3 className="text-2xl font-heading font-extrabold text-navy mb-2" data-id="element-333">
                      Got It! We're On It.
                    </h3>
                    <p className="text-slate text-base mb-4 leading-relaxed" data-id="element-334">
                      We'll text you within{' '}
                      <strong className="text-navy" data-id="element-335">15 minutes</strong> to
                      confirm details and arrange your quote.
                    </p>
                    <p className="text-gray-500 text-sm mb-6" data-id="element-336">
                      Need us sooner? Call us directly:
                    </p>
                    <a href="tel:0418381988" className="inline-flex items-center gap-2 bg-navy text-white px-6 py-3 rounded-xl font-bold text-base hover:bg-navy-600 transition-colors" data-id="element-337">
                      <Phone className="w-5 h-5 text-accent" data-id="element-338" />
                      0418 381 988
                    </a>
                    <button onClick={() => setIsSubmitted(false)} className="block mx-auto mt-4 text-sm text-accent font-bold hover:text-accent-600 transition-colors" data-id="element-339">
                      Submit another request
                    </button>
                  </motion.div>}
              </AnimatePresence>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Stats Bar */}
      <div className="absolute -bottom-6 left-0 right-0 z-20 px-4 hidden md:block" data-id="element-340">
        <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl border border-gray-100 py-6 px-8 grid grid-cols-4 divide-x divide-gray-100" data-id="element-341">
          <div className="text-center px-4" data-id="element-342">
            <div className="text-4xl font-heading font-extrabold text-accent mb-1" data-id="element-343">
              441+
            </div>
            <div className="text-sm font-bold text-navy uppercase tracking-wider" data-id="element-344">
              Google Reviews
            </div>
          </div>
          <div className="text-center px-4" data-id="element-345">
            <div className="text-4xl font-heading font-extrabold text-accent mb-1" data-id="element-346">
              5.0
            </div>
            <div className="text-sm font-bold text-navy uppercase tracking-wider" data-id="element-347">
              Star Rating
            </div>
          </div>
          <div className="text-center px-4" data-id="element-348">
            <div className="text-4xl font-heading font-extrabold text-accent mb-1" data-id="element-349">
              Same Day
            </div>
            <div className="text-sm font-bold text-navy uppercase tracking-wider" data-id="element-350">
              Most jobs
            </div>
          </div>
          <div className="text-center px-4" data-id="element-351">
            <div className="text-4xl font-heading font-extrabold text-accent mb-1" data-id="element-352">
              SOR
            </div>
            <div className="text-sm font-bold text-navy uppercase tracking-wider" data-id="element-353">
              Perth Specialists
            </div>
          </div>
        </div>
      </div>
    </section>;
}